import { Injectable, signal } from '@angular/core';
import { Network } from '@capacitor/network';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  // if you're not on Angular 16+, just use a BehaviorSubject instead of signal
  isOnline = signal(true);

  constructor() {
    this.init();
  }

  private async init() {
    // initial status
    const status = await Network.getStatus();
    this.isOnline.set(status.connected);

    // listen for changes
    Network.addListener('networkStatusChange', (status) => {
      this.isOnline.set(status.connected);
      console.log('Network status changed', status);
    });
  }
}
